<div class="image-div">
    <img src="{{environmentService.environment.useLogoFromFramework ? getFrameworkLogoUrl() : environmentService.environment.logoUrl}}" [alt]="'logo.alt' | translate" class="image"/>
</div>
